import {
    doGetQCXRequest,
  } from '../../utils/api/domain/domain-api-utils';
  import { TIPO_EMBARQUE_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';
  
  export async function fetchAll() {
    return doGetQCXRequest([
      TIPO_EMBARQUE_ENDPOINT
    ]);
  }
  
  export async function fetchById(id) {
    return doGetQCXRequest([
      TIPO_EMBARQUE_ENDPOINT,
      id
    ]);
  }